import { combineReducers } from 'redux'
import { type PrioritiesState } from '../../../interfaces'
import priorityListReducer from './priorityList'

const priorityReducer = combineReducers<PrioritiesState>({
  priorityList: priorityListReducer
})

export default priorityReducer
